import React from 'react'

function Footer() {
    return (
        
        <div className='footer'>
           <h5>copyright &copy; 2023 Pavan Raj</h5> 
        </div>
        
    )
}

export default Footer
